export default __webpack_public_path__ + "static/media/step1.9d01f431.jpg";